/* global axios */
import ApiClient from './ApiClient';

class CrmReportsAPI extends ApiClient {
  constructor() {
    super('crm/reports', { accountScoped: true });
  }

  getOrigins(params) {
    return axios.get(`${this.url}/origins`, { params });
  }

  // Recebido e previsto do período (parcelas), pros cards da aba Geral.
  getCash(params) {
    return axios.get(`${this.url}/cash`, { params });
  }

  // Os negócios por trás de um dos cards: `kind` é 'received' ou 'forecast'.
  getCashDeals(params) {
    return axios.get(`${this.url}/cash_deals`, { params });
  }

  exportOriginsCsv(params) {
    return axios.get(`${this.url}/origins.csv`, {
      params,
      responseType: 'blob',
    });
  }

  // Leads do quadro, com os mesmos filtros da tela. blob porque a resposta é
  // o arquivo em si, não JSON.
  exportLeads(params) {
    return axios.get(`${this.baseUrl()}/crm/exports`, {
      params,
      responseType: 'blob',
    });
  }
}

export default new CrmReportsAPI();
